import * as operationsActions from './actions';
import operationsEpics from './epics';
import reducer from './reducers';
import * as operationsSelectors from './selectors';

export { operationsActions, operationsEpics, operationsSelectors };

export default reducer;
